<div class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
  <!-- ▼ ▼ ▼ 見出し ▼ ▼ ▼ -->
  <div class="p-sub-column-layout02__title p-sub-column-layout02__title--has-btn">
    <div class="p-heading-area01">
      <h2 class="p-heading-area01__title c-heading-2" [innerHTML]="'label.filightMiles' | staticMsg"></h2>
    </div>
  </div>
  <!-- ▼ ▼ ▼ 本体 ▼ ▼ ▼ -->
  <div class="p-sub-column-layout02__body">
    <div class="p-sub-column-layout02__body-item">
      <div
        class="p-sub-column-layout02__mile p-sub-column-layout02__payment"
        [ngClass]="{ 'grey-bg': !isPlanValid && !isPC }"
      >
        <dl class="c-float-list01">
          <div class="c-float-list01__item">
            <dt class="c-float-list01__title" [innerHTML]="'label.perPassenger' | staticMsg"></dt>
            <dd class="c-float-list01__contents c-float-list01__contents--fs16">
              <span class="c-amount p-flight-miles__text-em">
                <ng-container *ngIf="accrualMiles">
                  <!-- 積算マイルが存在する場合 -->
                  <span class="c-amount__num c-amount__num--fs24">
                    {{ accrualMiles | amountFormat : undefined : 'MIL' }}
                  </span>
                </ng-container>
                <ng-container *ngIf="!accrualMiles">
                  <!-- 積算マイルが存在しない場合 -->
                  <span class="c-amount__num c-amount__num--fs24" [innerHTML]="'label.hyphen' | staticMsg"></span>
                </ng-container>
              </span>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
</div>
